import { PlayerConfig, PlayerStates } from "../../GameConfig/PlayerConfig.js";
import { InputConfig } from "../../GameConfig/GameConfig.js";
import State from "./states.js";

export default class Fly extends State {
  constructor(game) {
    super(PlayerStates.FLY);
    this.game = game;
  }

  enter() {}

  handleInput(input) {
    if (input.has(InputConfig.UP)) {
      this.game.player.y += PlayerConfig.UP_DIRECTION * PlayerConfig.SPEED;
    }
    if (input.has(InputConfig.DOWN)) {
      this.game.player.y += PlayerConfig.DOWN_DIRECTION * PlayerConfig.SPEED;
    }

    if (input.has(InputConfig.ATTACK)) {
      this.game.player.setState(PlayerStates.ATTACK);
    }
  }
}
